const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/GoToAppointmentRescheduleButton.tsx';
import { Button } from '@mui/material';
import * as React from 'react';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { currentPatientFromEmailLogin } from '@cistec/common_web/selectors/patientsSelectors';
import { goToAppointmentReschedule } from 'App/utils/history';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { appointmentIsWithin24Hours } from '@cistec/common_web/utils/kisim';
import { useFeatureFlags } from 'App/store/featureFlags';
import { selectUpcomingAppointment } from 'App/store/appointment';
import { useAllTreatmentResons } from 'App/store/schedulingPlan';

type GoToAppointmentRescheduleButtonProps = {
    appointment: StructuredAppointment;
    className?: string;
};

export const GoToAppointmentRescheduleButton = (props: GoToAppointmentRescheduleButtonProps) => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const { appointment } = props;

    const { data: featureFlags } = useFeatureFlags();

    const currentPatFromEmail = useSelector(currentPatientFromEmailLogin);
    const { data: bookableAppointmentKinds } = useAllTreatmentResons();

    const upcomingAppointment = useSelector(selectUpcomingAppointment);

    const isLessThan24Hours = appointmentIsWithin24Hours(appointment);
    const isBookable = bookableAppointmentKinds.includes(appointment.KIND?.FKEY!);

    if (
        !featureFlags.dashboard.appointmentBooking ||
        !isBookable ||
        (currentPatFromEmail && upcomingAppointment) ||
        isLessThan24Hours
    ) {
        return null;
    }

    const handleButtonClick = () => {
        goToAppointmentReschedule(history, appointment.TERMNR);
    };

    return (
        <Button className={cx(props.className)} variant={'contained'} color={'primary'} onClick={handleButtonClick}>
            {formatMessage(textMap.rescheduleAppointment)}
        </Button>
    );
};
